<app-layout>
  <main class="portal-content">
    <ng-container *ngIf="portalState$ | async as state">
      <ng-container [ngSwitch]="state.currentView">
        <app-home *ngSwitchCase="'home'"></app-home>
        <app-service-definition-details
          *ngSwitchCase="'service-details'"
          [serviceId]="state.serviceId"
          [blueprintId]="state.blueprintId">
        </app-service-definition-details>
        <app-environment-details
          *ngSwitchCase="'environment'"
          [envId]="state.envId">
        </app-environment-details>
        <app-faq *ngSwitchCase="'faq'"></app-faq>
        <div *ngSwitchDefault>{{ 'FEATURES.CONTAINER.LOADING' | transloco }}</div>
      </ng-container>
    </ng-container>
  </main>
</app-layout>
